import { RouteObject } from 'react-router-dom';
import PATH from './path';
import LoginPage from '@/src/pages/Login';
import ProtectedPublicRoute from '@/components/template/ProtectedPublicRoute';
import NotFoundPage from '@/src/pages/NotFound';
import ChangePasswordPage from '@/src/pages/ChangePassword';

const publicRoute: RouteObject[] = [
  {
    element: <ProtectedPublicRoute />,
    children: [
      {
        path: PATH.LOGIN,
        element: <LoginPage />,
      },
      {
        path: PATH.CHANGE_PASSWORD,
        element: <ChangePasswordPage />,
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];

export default publicRoute;
